import { gql } from "@apollo/client";

export const GET_SINGLE_INVOICE = gql`
  query invoice($objectId: ID) {
    invoice(objectId: $objectId) {
      objectId
      createdOn
      updatedOn
      customer {
        objectId
        user {
          name
          email
          phone
          memberInfo {
            objectId
          }
        }
      }
      createdOn
      invoicePayments {
        edges {
          node {
            objectId
            invoiceReceipt {
              paymentType
              balance
              bank {
                name
              }
              paidAmount
              chequeNo
              chequeDate
              chequeAmount
            }
          }
        }
      }
      invoicePackages {
        edges {
          node {
            objectId
            personalTrainingPackage {
              startDate
              endDate
              vatPercent
              discountAmount
              paidAmount
              requestedTrainer {
                user {
                  name
                }
              }
              package {
                name
                objectId
                actualPrice
              }
            }
            dietPlanPackage {
              startDate
              endDate
              vatPercent
              discountAmount
              paidAmount
              package {
                name
                objectId
                actualPrice
              }
            }
            membershipPackage {
              startDate
              endDate
              vatPercent
              discountAmount
              paidAmount
              package {
                name
                objectId
                actualPrice
              }
            }
          }
        }
      }
      createdBy {
        name
        objectId
      }
      actualPrice
      priceAfterDiscount
      note
      refundedAmount
      reminderTime
      discountedBy {
        user {
          name
        }
      }
      status
      totalQty
      totalVat
      finalPrice
      paidAmount
      totalDiscount
      outstandingAmount
    }
  }
`;
export const GET_SINGLE_RECEIPT_INVOICE = gql`
  query invoiceReceipt($objectId: ID) {
    invoiceReceipt(objectId: $objectId) {
      createdOn
      objectId
      customer {
        user {
          name
          email
          phone
          memberInfo {
            objectId
          }
        }
      }
      paidAmount
      bank {
        name
      }
      chequeNo
      chequeDate
      chequeAmount
      note
      paymentType
      balance
      invoiceAmount
      invoices {
        edges {
          node {
            actualPrice
          }
        }
      }
      packages {
        edges {
          node {
            objectId
            dietPlanPackage {
              package {
                name
                actualPrice
              }
              startDate
              endDate
            }
            personalTrainingPackage {
              package {
                name
                actualPrice
              }
              startDate
              endDate
            }
            membershipPackage {
              package {
                name
                actualPrice
              }
              startDate
              endDate
            }
          }
        }
      }
    }
  }
`;
